import { ComponentType } from 'react';
import { makeAutoObservable, observableRef } from 'mobx';

import useStore from '@/common/hooks/useStore';
import { RowEndComponentProps } from '@/common/stores/GlobalSearchConfigStore.types';

class GlobalSearchConfigStore {
  rowEndComponent: Nullable<ComponentType<RowEndComponentProps>> = null;

  setRowEndComponent = (component: ComponentType<RowEndComponentProps>) => {
    this.rowEndComponent = component;
  };

  resetRowEndComponent = () => {
    this.rowEndComponent = null;
  };

  constructor() {
    makeAutoObservable(this, {
      rowEndComponent: observableRef,
    });
  }
}

export const useGlobalSearchConfigStore = () => useStore(GlobalSearchConfigStore);

export const globalSearchConfigStore = new GlobalSearchConfigStore();
export default GlobalSearchConfigStore;
